import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, Surface, Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { openInNewTab } from '@app/redux/utils';

import styles from './styles.module.scss';

const MobileHelp = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation(['Network', 'Global']);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    const helpUrl = t('Global:viasatHelpLink');
    dispatch(openInNewTab(helpUrl));
  };

  return (
    <Surface data-cy="MobileHelp" className={styles['container']}>
      <div className={styles['textContainer']}>
        <Txt variant="bodyLargeBold" component="span">
          {t('help.stillHaveQuestions')}
        </Txt>
        <Txt variant="bodyLargeRegular" component="span">
          {t('help.learnMore')}
        </Txt>
      </div>
      <Button variant="secondary" className={styles['learnMoreButton']} onClick={handleClick}>
        {t('help.visitHelpCenter')}
      </Button>
    </Surface>
  );
};

export default MobileHelp;
